<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <!-- IE 2026 11 03 / ODOO-349799 (wizard-steps): класс панели из описания бэка (attr.cssClass, напр. exchange-wizard-row — полоса шагов Compare & merge) -->
        <div class="commandPanel" :class="attr?.cssClass || ''">
            <div class="commandPanel-menu">
                <component
                    v-for="attrM in commandPanel"
                    :key="attrM.html_id"
                    :widget_id="widget_id" 
                    :is="attrM.component"
                    :attr_id="attrM.id"
                    :initialAttr="attrM" 
                />
            </div>
        </div>
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'

export default {
    props: [
        'widget_id',
        'attr_id',
    ],
    data: () => ({ 
        WIDGET: {},
        attr: {},   // IE 2026 11 03 / ODOO-349799 (wizard-steps): объявлен — шаблон читает attr.cssClass (widget_attr_set кладёт описание, как в AttrButton)
        commandPanel: [],
    }),
    setup() {
        const store = useMainStore();
        return { store }
    },
    created() {
        // console.log(`created ${this.attr_id}`)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    methods: {
        content_Changed() {
            this.store.widget_attr_set(this)
            this.commandPanel = this.attr.attrs || []
            this.store.prepare_attrs(this.commandPanel, this.attr.html_id || this.attr.id || 'commandPanel')
            for (let command of this.commandPanel) {
                this.store.prepare_actionMenu(command)
            }
        },
    }
}
</script>

<style scoped>
.commandPanel{
    display: flex;
    width:-webkit-fill-available !important;
    padding: 6px;
}
.commandPanel-menu{
    display: flex;
    align-items: center;
    padding: 0 6px;
}
</style>